<template lang="pug">
  //- router-view
</template>

<script>
import mapChartsElements from '@/mixins/mapChartsElements'

export default {
  name: 'CRMMain',
  data () {
    return {
      all: '$t("all")',
      gisDataCategorySelected: 'dataSourceAll',
      gisDataCategory: [{
        label: 'heat map',
        options: [ {
          value: 'dataSourceAll',
          label: 'All',
          show: false
        }, {
          value: 'dataSourceSolicitations',
          label: 'Solicitations',
          show: false
        }, {
          value: 'dataSourceConsultations',
          label: 'Consultations',
          show: false
        }, {
          value: 'dataSourceComplaints',
          label: 'Complaints',
          show: false
        }, {
          value: 'dataSourceDamage',
          label: 'Damage',
          show: false
        }]
      }, {
        label: 'Base map',
        options: [{
          value: 'dataSourceNumComplaints',
          label: 'Nº Complaints',
          show: false
        }]
      }],
      gisDataComplaintsSelected: ['presenceSolicitations', 'webSolicitations', 'appSolicitations'],
      gisDataComplaints: [{
        value: 'presenceSolicitations',
        label: 'Presence'
      }, {
        value: 'webSolicitations',
        label: 'Portal'
      }, {
        value: 'appSolicitations',
        label: 'App'
      }]
    }
  },
  mixins: [ mapChartsElements ],
  methods: {
    setFilter (category, categorySelected) {
      this.gisDataCategory = category
      this.gisDataCategorySelected = categorySelected
    },
    loadDataFilter (categoryInput) {
      let mapsHeatArray = document.getElementById('dataIframe').contentWindow.viewer.imageryLayers._layers
      let valorCapa
      for (var i = 1; i < mapsHeatArray.length; i++) {
        valorCapa = mapsHeatArray[i]._imageryProvider.name.layerName
        if (categoryInput === valorCapa) {
          mapsHeatArray[i].show = true
        } else {
          mapsHeatArray[i].show = false
        }
      }
    },
    loadDataFilterShow (categoryInput) {
      let mapsComplaintsArray = document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
      let valorCapa
      for (var i = 1; i < mapsComplaintsArray.length; i++) {
        valorCapa = mapsComplaintsArray[i].name.name
        if (categoryInput === valorCapa) {
          mapsComplaintsArray[i].show = true
        } else {
          mapsComplaintsArray[i].show = false
        }
      }
    },
    getFilterCategory () {
      return this.gisDataCategory
    },
    getFilterCategorySelected () {
      return this.gisDataCategorySelected
    },
    setFilterComplaints (complaints, complaintsSelected) {
      this.gisDataComplaints = complaints
      this.gisDataComplaintsSelected = complaintsSelected
    },
    loadDataFilterComplaints () {
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(this.gisDataComplaints)
    },
    getFilterComplaints () {
      return this.gisDataComplaints
    },
    getFilterComplaintsSelected () {
      return this.gisDataComplaintsSelected
    }
  },
  mounted () {
    // console.log('filtros', this.gisDataCategory);
  },
  activated () {
    this.$emit('controlCollapsePanel', true)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/CRMMain.vue